import React, { Component } from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from '../components/CustomAlert.js';
import Whatsapp from './WhatsappButton.js';
import SaveStepButton from './SaveStepButton.js';

class LoanTypeForm extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { handleSubmit, submitting, error, loanTypeSelected } = this.props;

        const loan_types = [
            {id:0 , name:'Cosecha y Acarreo'},
        ];

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_loan_type" description="Personal info"/>
                        <FormattedHTMLMessage id="app.step_loan_type_credit" description="Personal info Credit"/>
                        <div className="show-desktop">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveLoanType)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="loan_type" defaultValue="Línea de crédito" label="Línea de crédito" attributeName='loan_type' attributeOptions={loan_types}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

LoanTypeForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const selector = formValueSelector('LoanTypeForm')

LoanTypeForm = connect(
    state => {
        const loanTypeSelected = selector(state, 'loan_type')
        return {
            loanTypeSelected
        }
    }
)(LoanTypeForm)

let validate = generateValidator([{name: 'loan_type', required: true}])
LoanTypeForm = TopScrolleable(LoanTypeForm);

LoanTypeForm = reduxForm({
    form: 'LoanTypeForm', // a unique name for this form
    validate
})(LoanTypeForm);

LoanTypeForm = withAuthControl(LoanTypeForm);

export default LoanTypeForm;


/** WEBPACK FOOTER **
 ** ./src/components/LoanTypeForm.js
 **/